import React from 'react';
import { useEmail } from '../../hooks/useEmail';
import BaseAssignmentModal from './BaseAssignmentModal';
import PersonIcon from '@mui/icons-material/Person';

// "Benutzer zuweisen" — hands a mail to the colleagues who should take care of
// it. Everyone picked here finds the mail under "Meine". The options come from
// the mail domain (active employees with a mail right who could open this very
// mail), not from the user administration, so no `user:read` right is needed to
// assign. The list opens filtered to Leitung and can be searched.
const UserAssignmentModal = ({ open, onClose, onAssign, loading, assignedUsers = [], mailId }) => {
  const { fetchAssignableUsers } = useEmail();

  return (
    <BaseAssignmentModal
      open={open}
      onClose={onClose}
      onAssign={onAssign}
      loading={loading}
      assignedItems={assignedUsers}
      fetchItems={() => fetchAssignableUsers(mailId)}
      title='Benutzer zuweisen'
      itemNameKey='displayName'
      itemSecondaryKey='branchNames'
      searchPlaceholder='Nach Name oder Standort suchen…'
      filterFlagKey='isLeadership'
      filterFlagLabel='Nur Leitung'
      icon={PersonIcon}
    />
  );
};

export default UserAssignmentModal;
